import { StyleSheet, I18nManager } from 'react-native';

import Colors from '../../Themes/Colors';
import Fonts from '../../Themes/Fonts';

const isRTL = I18nManager.isRTL;
export default StyleSheet.create({
  borderBottom: {
    borderBottomWidth: 1,
  },
  container: (theme, type) => ({
    borderColor: theme.colors.VFDivider[type],
    borderTopWidth: 1,
    paddingBottom: 15,
    paddingTop: 15,
  }),
  contentContainer: {
    marginLeft: isRTL ? 0 : 2,
    marginRight: isRTL ? 2 : 0,
    paddingTop: 20,
  },
  headdingContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  headdingText: {
    color: Colors.dark_grey,
    ...Fonts.type.bold,
    fontSize: 20,
    marginLeft: isRTL ? 0 : 17,
    marginRight: isRTL ? 17 : 0,
  },
  textWithIcon: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  iconSecondery: {
    tintColor: Colors.white,
  },
  opacityStyle: {
    opacity: 0.4,
  },
});
